/**
 * Central lifecycle classification for Phase 4 documents.
 *
 * Public API is unchanged. Retention intervals live in lifecyclePolicy.cjs
 * so the trusted backend can apply the same policy without duplicating them.
 *
 * CRA webpack must compile that .cjs file as JavaScript (see
 * scripts/react-scripts-with-cjs.cjs). If it is treated as an asset URL,
 * DATA_CLASSES is undefined and userLibrary init throws.
 */

import policy from './lifecyclePolicy.cjs';

export const USER_AUTHORIZED_PROVIDER_REFRESH_MS =
  policy.USER_AUTHORIZED_PROVIDER_REFRESH_MS;
export const YOUTUBE_METADATA_REFRESH_MS = policy.YOUTUBE_METADATA_REFRESH_MS;
export const YOUTUBE_METADATA_HARD_EXPIRY_MS =
  policy.YOUTUBE_METADATA_HARD_EXPIRY_MS;
export const CATALOG_REVIEW_CLOSED_RETENTION_MS =
  policy.CATALOG_REVIEW_CLOSED_RETENTION_MS;
export const DATA_CLASSES = policy.DATA_CLASSES;
export const normalizeDataClass = policy.normalizeDataClass;
export const retentionPolicyFor = policy.retentionPolicyFor;
export const expiresAtFromPolicy = policy.expiresAtFromPolicy;
export const operationalLifecycle = policy.operationalLifecycle;
export const buildLifecycle = policy.buildLifecycle;
